// Chrome, Safari and Firefox wording for a fetch that never got a response; Sentry's fetch
// instrumentation appends " (<host>)". Anchored so "Failed to fetch dynamically imported module"
// and application errors that merely mention a fetch do not match.
const NETWORK_FETCH_FAILURE =
  /^(?:Failed to fetch|Load failed|NetworkError when attempting to fetch resource\.)(?: \([^)]*\))?$/;

/**
 * A `fetch` rejected before any HTTP response: offline, DNS, TLS, CORS or a blocked request. The
 * browser reports all of these the same way, so this says the transport failed, not why.
 */
export function isNetworkFetchFailure(error: unknown): boolean {
  return error instanceof TypeError && NETWORK_FETCH_FAILURE.test(error.message);
}
